/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from "react";

const indicatorStyles = {
  background: "#fff",
  width: 8,
  height: 8,
  display: "inline-block",
  margin: "0 8px",
  borderRadius: "100%",
  background: "#DCDBDB",
  cursor: "pointer",
};

const selectedIndicatorStyles = {
  ...indicatorStyles,
  width: 12,
  height: 12,
  background: "#EF60A3",
};

export default function Indicator({
  onClickHandler,
  isSelected,
  index,
  label,
}) {
  if (isSelected) {
    return (
      <li
        style={selectedIndicatorStyles}
        title={`Selected: ${label} ${index + 1}`}
        aria-label={`Selected: ${label} ${index + 1}`}
      />
    );
  }

  return (
    <li
      style={indicatorStyles}
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      value={index}
      key={index}
      role="button"
      tabIndex={0}
      title={`${label} ${index + 1}`}
      aria-label={`${label} ${index + 1}`}
    />
  );
}
